export class Point2D {
  public X: number = 0;
  public Y: number = 0;

  constructor(X: number, Y: number) {
    this.X = X;
    this.Y = Y;
  }

  public add(point: Point2D): Point2D {
    return new Point2D(this.X + point.X, this.Y + point.Y);
  }

  public subtract(point: Point2D): Point2D {
    return new Point2D(this.X - point.X, this.Y - point.Y);
  }

  public multiply(value: number): Point2D {
    return new Point2D((this.X * value),
                       (this.Y * value));
  }

  public divide(value: number): Point2D {
    return new Point2D((this.X / value),
                       (this.Y / value));
  }

  public produitScalaire(V1: Point2D): number {
    return (this.X * V1.X) + (this.Y * V1.Y);
  }

  public norme(): number {
    return Math.sqrt(this.produitScalaire(this));
  }

  public normalize(): Point2D {
    return this.divide(this.norme());
  }

  public distance(target: {X: number, Y: number} = {X: 0, Y: 0}): number {
    return Math.sqrt( Math.pow(target.X - this.X, 2) + Math.pow(target.Y - this.Y, 2));
  }
}

export class Point3D {
  public X: number = 0;
  public Y: number = 0;
  public Z: number = 0;

  constructor(X: number, Y: number, Z: number) {
    this.X = X;
    this.Y = Y;
    this.Z = Z;
  }

  public multiply(value: number): Point3D {
    return new Point3D((this.X * value),
                       (this.Y * value),
                       (this.Z * value));
  }
  public produitVectoriel(V1: Point3D): Point3D {
    return new Point3D(((this.Y * V1.Z) - (this.Z * V1.Y)),
                       ((this.Z * V1.X) - (this.X * V1.Z)),
                       ((this.X * V1.Y) - (this.Y * V1.X)));
  }

  public divide(value: number): Point3D {
    return new Point3D((this.X / value),
                       (this.Y / value),
                       (this.Z / value));
  }

// tslint:disable-next-line:no-shadowed-variable
  public produitScalaire(V1: Point3D): number {
    return (this.X * V1.X) + (this.Y * V1.Y) + (this.Z * V1.Z);
  }

  public norme(): number {
    return Math.sqrt(this.produitScalaire(this));
  }

  public normalize(): Point3D {
    return this.divide(this.norme());
  }
}

export interface Rect {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

